import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFoundPage: React.FC = () => {
  const { t, i18n } = useTranslation();

  // 热门城市快捷链接
  const hotCities = [
    { id: 'bj', name: '北京', enName: 'Beijing' },
    { id: 'sh', name: '上海', enName: 'Shanghai' },
    { id: 'sz', name: '深圳', enName: 'Shenzhen' },
    { id: 'gz', name: '广州', enName: 'Guangzhou' },
  ];

  const getCityName = (city: { name: string; enName: string }) => {
    return i18n.language.startsWith('zh') ? city.name : city.enName;
  };

  return (
    <div className="min-h-screen bg-slate-50 pt-16">
      <div className="max-w-4xl mx-auto px-4 py-16 sm:py-24 text-center">
        
        {/* 大号 404 数字 - 使用 SVG 确保显示 */}
        <div className="mb-8">
          <svg 
            viewBox="0 0 400 160" 
            className="w-full max-w-md mx-auto h-auto"
            aria-hidden="true"
          >
            <text 
              x="200" 
              y="110" 
              textAnchor="middle" 
              className="fill-slate-300" 
              style={{ fontSize: '140px', fontWeight: 900, fontFamily: 'system-ui, -apple-system, sans-serif' }}
            >
              4
              <tspan className="fill-blue-500">0</tspan>
              4
            </text>
          </svg>
        </div>

        {/* 标题 */}
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-black text-slate-900 mb-4">
          {t('notFound.title', '页面走丢了...')}
        </h1>

        {/* 描述 */}
        <p className="text-slate-500 text-base sm:text-lg mb-12 max-w-md mx-auto leading-relaxed">
          {t('notFound.description', '您访问的页面不存在或已被移除，请检查链接是否正确')}
        </p>

        {/* 按钮组 */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-slate-900 text-white px-8 py-4 rounded-xl font-bold text-base hover:bg-blue-600 transition-all shadow-lg shadow-slate-300 active:scale-95"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            {t('notFound.backHome', '返回首页')}
          </Link>
          <Link
            to="/jobs"
            className="inline-flex items-center justify-center gap-2 bg-white text-slate-900 px-8 py-4 rounded-xl font-bold text-base border-2 border-slate-200 hover:border-blue-500 hover:text-blue-600 transition-all active:scale-95"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            {t('notFound.viewJobs', '浏览所有职位')}
          </Link>
        </div>

        {/* 分割线 */}
        <div className="flex items-center gap-4 mb-8 max-w-sm mx-auto">
          <div className="flex-1 h-px bg-slate-300"></div>
          <span className="text-xs font-bold text-slate-400 uppercase tracking-widest">
            {t('notFound.orTry', '或者试试')}
          </span>
          <div className="flex-1 h-px bg-slate-300"></div>
        </div>

        {/* 热门城市链接 */}
        <div className="flex flex-wrap justify-center gap-3">
          {hotCities.map((city) => (
            <Link
              key={city.id}
              to={`/cities/${city.id}`}
              className="px-5 py-2.5 bg-white text-slate-600 rounded-full text-sm font-semibold hover:bg-blue-50 hover:text-blue-600 transition-colors border border-slate-200"
            >
              {getCityName(city)}
            </Link>
          ))}
          <Link
            to="/offices"
            className="px-5 py-2.5 bg-blue-600 text-white rounded-full text-sm font-bold hover:bg-blue-700 transition-colors"
          >
            {t('notFound.allOffices', '全部城市')} →
          </Link>
        </div>

      </div>
    </div>
  );
};

export default NotFoundPage;
